<template>
  <section class="pd4 HomeNews">
    <div class="auto">
      <div class="HomeTit wow fadeInUp">
        <h1 class="cn">{{ $t('pages.home.newsCenter') }}</h1>
        <p class="en OswaldMedium">News center</p>
      </div>
      <div class="Focus wow fadeInLeft">
        <ul class="slider">
          <li class="item" v-for="(news, index) in paginatedTopNew" :key="index">
            <a :href="`/showNews?newsSn=${news.newsn}`">
              <div class="imgbox Scale-img"><span
                  :style="{ backgroundImage: `url(${news.image || 'static/picture/changdi.png'})` }"></span></div>
              <div class="info">
                <div class="tit">{{ formatDate(news.date) }} | {{ news.title }}</div>
                <p class="p">{{ news.summary }}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="RecList wow fadeInRight">
        <ul>
          <li class="itemhover" v-for="(rec, index) in paginatedNews" :key="index">
            <a :href="`/showNews?newsSn=${rec.newsn}`">
              <div class="imgbox"><span
                  :style="{ backgroundImage: `url(${rec.image || 'static/picture/Bio.png'})` }"></span></div>
              <div class="ti">
                <span class="tit">{{ formatDate(rec.date) }} | {{ rec.title }}</span>
                <span class="date">{{ formatDate(rec.date) }}</span>
              </div>
              <p class="p">{{ rec.summary }}</p>
            </a>
          </li>
        </ul>
      </div>
      <div class="tr clear"><a href='/NewsCenter' class="bluebtn w148">{{ $t('pages.home.moreNews') }}</a></div>
    </div>
  </section>
</template>

<script>
import { getNewsListUser, getTopNewsUser } from '@/utils/newsget';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export default {
  name: 'indexNews',
  setup() {
    const { t } = useI18n();

    const defaultNewsItems = computed(() => [
      {
        link: '/NewsCenter',
        image: 'static/picture/changdi.png',
        title: t('pages.news.center'),
        date: '2024-06-22',
        summary: t('seo.description')
      }
    ]);

    const defaultRecItems = computed(() => [
      {
        link: '/NewsCenter',
        image: 'static/picture/Bio.png',
        title: t('seo.title'),
        date: '2024-04-25',
        summary: t('seo.description')
      },
      {
        link: '/NewsCenter',
        image: 'static/picture/Bio.png',
        title: t('seo.title'),
        date: '2024-04-24',
        summary: t('seo.description')
      },
      {
        link: '/NewsCenter',
        image: 'static/picture/Bio.png',
        title: t('pages.home.advantageousTech'),
        date: '2024-04-08',
        summary: t('seo.description')
      },
      {
        link: '/NewsCenter',
        image: 'static/picture/Bio.png',
        title: t('pages.home.advantageousTech'),
        date: '2024-03-18',
        summary: t('seo.description')
      },
    ]);

    return { t, defaultNewsItems, defaultRecItems };
  },
  data() {
    return {
      i: 0,
      orders: [],
      newsList: [],
      newsTopList: [],
      listVec: [],
    };
  },
  methods: {
    redirectPage_(inputID) {
      var inputValue = document.getElementById(inputID).value;
      if (!(/^\d+$/).test(inputValue)) { document.getElementById(inputID).value = '1'; return; }
      if (inputValue <= 0) { inputValue = 1; } if (inputValue > 22) { inputValue = 22; }
      location.href = '/AboutWeUs/index.aspx?page={$wtl_pager}'.replace('{$wtl_pager}', inputValue);
    },

    async getAllNewsList() {

      try {
        const response = await getNewsListUser();

        this.newsList = null;

        this.orders = response.data;

        this.newsList = [...this.orders, ...this.defaultRecItems];

      } catch (error) {
        console.error('Error fetching address list:', error);
      }
    },
    async getTopNews() {

      try {
        const response = await getTopNewsUser();

        this.newsTopList = null;

        this.newsTopList = [...response.data, ...this.defaultNewsItems];

      } catch (error) {
        console.error('Error fetching address list:', error);
      }
    },
    mergeArrays() {
      const orderMap = new Map(this.order.map(item => [item.newsn, item]));

      const mergedList = this.newslist.map(newsItem => {
        const matchedOrder = orderMap.get(newsItem.newsn.toString());
        if (matchedOrder) {
          return { ...newsItem, ...matchedOrder };
        }
        return newsItem;
      });

      const unmatchedOrders = this.order.filter(orderItem =>
        !this.newslist.some(newsItem => newsItem.newsn.toString() === orderItem.newsn)
      );
      this.newsList = [...mergedList, ...unmatchedOrders];
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

  },
  computed: {
    paginatedNews() {
      return this.newsList.slice(0, 4);
    },
    paginatedTopNew() {
      return this.newsTopList.slice(0, 1);
    },
  },
  mounted() {
    this.getTopNews();
    this.getAllNewsList();
    this.listVec = this.newsList;

    this.i = 100;
  }
};
</script>

<style scoped>
</style>
